import { type Common } from '../common.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async isCopilotEnabledForJob(jobId: number): Promise<boolean> {
    const url = this.common.constructPath(`/copilot/jobs/${jobId}/enabled`);
    const { copilotEnabled } = await this.common.getJSON(url);
    return copilotEnabled;
  }
}
